import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { DataField } from '../api/types';

const useDataFieldOptions = () => {
    const { t } = useTranslation('consentsAndDeclarations');

    const { state } = useLocation();

    return useMemo(() => {
        if (state?.eventId) {
            return [
                {
                    value: DataField.None,
                    label: t('consentsAndDeclarations:options.dataField.none'),
                },
            ];
        }
        const dataFieldOptions = [
            {
                value: DataField.None,
                label: t('consentsAndDeclarations:options.dataField.none'),
            },
            {
                value: DataField.DataProcessing,
                label: t('consentsAndDeclarations:options.dataField.dataProcessing'),
            },
        ];

        return dataFieldOptions;
    }, [state?.eventId, t]);
};

export default useDataFieldOptions;
